import GameInfoModal from 'components/GlobalModals/GameInfoModal/GameInfoModal';

export default GameInfoModal;
